import { render } from "./PartnershipBoardList.vue?vue&type=template&id=d4ab9b2e&scoped=true&ts=true"
import script from "./PartnershipBoardList.vue?vue&type=script&lang=ts"
export * from "./PartnershipBoardList.vue?vue&type=script&lang=ts"

import "./PartnershipBoardList.vue?vue&type=style&index=0&id=d4ab9b2e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ab9b2e"]])

export default __exports__